import React from "react";
import { Card, Statistic } from "antd";
import { SwapOutlined } from "@ant-design/icons";

const AvgRefundValueCard = ({ value = 0 }) => {
  return (
    <Card className="dashboard-card">
      <div className="">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">AVG REFUND VALUE</h5>
          <div className="icon-box purple">
            <SwapOutlined />
          </div>
        </div>
        
        <Statistic
          value={value}
          precision={2}
          prefix="$"
          valueStyle={{ color: "#cf1322", fontWeight: "bold", fontSize: "24PX" }}
        />
      </div>
    </Card>
  );
};

export default AvgRefundValueCard;
